import React, { useEffect, useState } from 'react';
import Table from '../../components/Table';
import api from '../../services/api';
import { useSelector } from 'react-redux';
import { formatNumberPtbr } from 'utils/format-number-ptbr';

function Unity() {
  const [unities, setUnity] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Sigla/Símbolo',
      editable: 'never',
      field: 'sigla',
      hideFilterIcon: true,
      render: (rowData) => (rowData.multiplier ? `${formatNumberPtbr(rowData.multiplier)} (${rowData.sigla})` : `${rowData.sigla}`),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/unities?showCustomUnities=true');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setUnity(response.data);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    unities.map((unity) => (unity.id === newData.id ? tempData.push(newData) : tempData.push(unity)));
    setUnity(tempData);
  }

  return (
    <Table
      title="Medidas"
      route="/unities/"
      routeAdd="/unity/"
      columns={columns}
      data={unities}
      setData={setData}
      dataLoaded={openProgress}
      isMeasurements
    />
  );
}

export default Unity;
